import { render } from "./FreeReportReader.vue?vue&type=template&id=55175dac&scoped=true"
import script from "./FreeReportReader.vue?vue&type=script&lang=js"
export * from "./FreeReportReader.vue?vue&type=script&lang=js"

import "./FreeReportReader.vue?vue&type=style&index=0&id=55175dac&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2221027770/src/vedicastrologyreport-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55175dac"]])

export default __exports__